import React, { useState } from "react";
import { Container, Form } from "reactstrap";
import { useFormik } from "formik";
import Breadcrumbs from "../../../../components/Common/Breadcrumb";
import { useHistory, useParams } from "react-router-dom";
import ResultHandler from "../../../../components/ResultHandler";
import { editContract, getContract } from "../../../../api/contract";
import FormButtonHandler from "../../../../components/FormButtonHandler";
import { useResponse } from "../../../../hooks/useResponse";
import { useTranslation } from "react-i18next";
import { useGetInstence } from "../../../../hooks/useGetInstence";
import ContractForm from "./ContractForm";
import FIELDS from "./CONSTANT";
import * as Yup from "yup";

const TYPES = {
  select: null,
  "add-more": [],
  "add-more-v2": [],
  checkbox: false,
  file: null,
  date: null,
};

const initialValues = {};
const FIELDS_VALIDATION = {};

FIELDS.forEach((f) => {
  initialValues[f.key] = TYPES[f.type] ? TYPES[f.type] : "";
  if (!["add-more-v2", "checkbox"].includes(f.type)) {
    if (f.type == "file") {
      FIELDS_VALIDATION[f.key + "_preview"] = Yup.string().required(
        "This Field Is Required"
      );
    } else if (f.type == "file-v2") {
      FIELDS_VALIDATION[f.key] = Yup.mixed();
      // .required("This Field Is Required");
    } else {
      FIELDS_VALIDATION[f.key] = Yup.string().required(
        "This Field Is Required"
      );
    }
  }
});

const EditContract = () => {
  let navigate = useHistory();

  const { t } = useTranslation();

  const params = useParams();
  const [editedContract, setEditedContract] = useState(null);

  const { instenceLoading, instenceError, instenceSuccess } = useGetInstence(
    getContract,
    params.contractId,
    (response) => {
      setEditedContract({
        ...response.data.data.companyContract,
      });
    }
  );

  const { setData, loading, error, success } = useResponse(editContract, () => {
    navigate.goBack();
  });

  // Form validation
  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    initialValues: {
      ...editedContract,
    },
    validationSchema: Yup.object(FIELDS_VALIDATION),
    onSubmit: (values) => {
      values.company = null;

      let formData = new FormData();
      for (let key in values) {
        if (Array.isArray(values[key])) {
          formData.append(key, JSON.stringify(values[key]));
        } else {
          formData.append(key, values[key]);
        }
      }
      setData({ type: "edit", id: params.contractId, data: formData });
    },
  });

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs
            title={t("Contracts")}
            breadcrumbItem={t("btns.Edit") + " " + t("Contract")}
          />

          {editedContract && (
            <Form
              className="needs-validation"
              onSubmit={(e) => {
                e.preventDefault();
                validation.handleSubmit();
                return false;
              }}
            >
              <ContractForm validation={validation} />

              <FormButtonHandler btnTxt="Edit" loading={loading} />
            </Form>
          )}

          <ResultHandler
            loading={instenceLoading}
            error={error}
            success={success}
            successMsg={"Updated Successfully!"}
          />
        </Container>
      </div>
    </React.Fragment>
  );
};

export default EditContract;
